<template>
  <v-row
    align="center"
    justify="center"
    no-gutters
    class="background"
  >
    <v-card
      width="90%"
      max-width="400px"
      class="pa-4"
    >
      <v-form>
        <v-col cols="12 px-0">
          <v-text-field
            type="text"
            label="Пользователь"
            :error-messages="loginErrors"
            @input="$v.login.$touch()"
            @blur="$v.login.$touch()"
            required
            v-model="login"
            autocomplete="username"
          >
            <template v-slot:prepend>
              <v-icon>mdi-account-outline</v-icon>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12 px-0">
          <v-text-field
            label="Пароль"
            :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
            :type="passwordVisible ? 'text' : 'password'"
            :error-messages="passwordErrors"
            @input="$v.password.$touch()"
            @blur="$v.password.$touch()"
            @click:append="passwordVisible = !passwordVisible"
            v-model="password"
            autocomplete="password"
          >
            <template v-slot:prepend>
              <v-icon>mdi-lock-outline</v-icon>
            </template>
          </v-text-field>
        </v-col>
        <v-card-actions class="px-0">
          <v-spacer></v-spacer>
          <v-btn
            class="px-8"
            color="primary"
            :loading="submiting"
            @click.prevent="okClick"
          >Войти</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-row>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import HandledError from '@/utils/handledError'

export default {
  data: () => ({
    login: '',
    password: '',
    passwordVisible: false,
    submiting: false
  }),

  computed: {
    loginErrors () {
      const errors = []
      if (!this.$v.login.$dirty) return errors
      !this.$v.login.maxLength &&
        errors.push(`Не более ${this.$v.login.$params.maxLength.max} символов, пожалуйста`)
      !this.$v.login.minLength &&
        errors.push('Слишком короткое имя пользователя')
      !this.$v.login.required && errors.push('Введите имя пользователя')
      return errors
    },
    passwordErrors () {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.maxLength &&
        errors.push(`Не более ${this.$v.password.$params.maxLength.max} символов, пожалуйста`)
      !this.$v.password.required && errors.push('Введите пароль')
      return errors
    }
  },

  validations: {
    login: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(20)
    },
    password: {
      required,
      maxLength: maxLength(20)
    }
  },

  mounted () {
    this.$store.dispatch('auth/logout')
  },

  methods: {
    okClick () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }

      this.submiting = true
      this.$store.dispatch('auth/login', {
        login: this.login,
        password: this.password
      }).then(() => {
        this.$router.push('/')
      }).catch((err) => {
        if (err instanceof HandledError) return
        // любая не обработанная ошибка с сервера (в данном случае это только неверные логин/пароль)
        if (err?.response?.data?.message) {
          this.$message('error', err.response.data.message, 10000)
        } else {
          // Ошибка в js
          this.$router.push(`/error?message=${err.message}&from=${this.$router.currentRoute.path}`)
        }
      }).finally(() => {
        this.submiting = false
      })
    }
  }
}
</script>
